function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962c-0.49,-0.38 -4.527,-3.542 -8.427,-7.515c-4.378,-4.46 -8.78,-12.335 -8.78,-12.335l0.001,0c-1.745,-2.968 -2.745,-6.424 -2.745,-10.112c0,-11.038 8.962,-20 20,-20l0.129,0c10.979,0.07 19.871,9.005 19.871,20c0,3.688 -1,7.144 -2.745,10.112l0.001,0c0,0 -4.402,7.875 -8.78,12.335c-4.16,4.238 -8.476,7.553 -8.476,7.553l-0.049,-0.038Z",
    style: {
      fill: "#19191e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962c-0.49,-0.38 -4.527,-3.542 -8.427,-7.515c-4.378,-4.46 -8.78,-12.335 -8.78,-12.335l0.001,0c-1.745,-2.968 -2.745,-6.424 -2.745,-10.112c0,-11.038 8.962,-20 20,-20l0.129,0c10.979,0.07 19.871,9.005 19.871,20c0,3.688 -1,7.144 -2.745,10.112l0.001,0c0,0 -4.402,7.875 -8.78,12.335c-4.16,4.238 -8.476,7.553 -8.476,7.553l-0.049,-0.038Zm15.559,-20.825l0.021,-0.038c1.57,-2.671 2.469,-5.781 2.469,-9.099c-0,-9.896 -8.003,-17.937 -17.877,-18c-0,0 -0.129,0 -0.123,0c-9.934,0 -18,8.066 -18,18c-0,3.318 0.899,6.428 2.469,9.099l0.021,0.037c-0,0 4.237,7.607 8.461,11.91c2.718,2.768 5.503,5.133 7.049,6.395c1.543,-1.26 4.33,-3.625 7.049,-6.395c4.224,-4.303 8.461,-11.91 8.461,-11.91l-0,0.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.847,14.245l-4.418,0l0,0.117c0.596,0.043 1.192,0.247 1.192,0.915c0,0.422 -0.291,0.93 -0.669,1.366l0.073,0.087c0.683,-0.595 1.541,-1.322 2.296,-1.787c0.538,-0.334 1.076,-0.538 1.526,-0.581l0,-0.117Zm0.364,9.258l-0,-0.116c-0.654,-0.146 -1.163,-0.654 -1.657,-1.178c-0.77,-0.813 -2.718,-3.342 -3.532,-4.519l-1.322,1.497c0.567,0.959 1.308,2.02 1.991,2.877c0.843,1.046 1.439,1.25 2.354,1.352c0.654,0.072 1.831,0.087 2.166,0.087Zm-9.389,-1.802c0,1.206 -0.319,1.555 -1.22,1.686l-0,0.116l4.519,-0l0,-0.116c-0.857,-0.131 -1.206,-0.436 -1.206,-1.686l0,-5.654c0,-1.249 0.349,-1.555 1.206,-1.685l0,-0.117l-4.519,0l-0,0.117c0.901,0.13 1.22,0.479 1.22,1.685l0,5.654Z",
    style: {
      fill: "#fff3cb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.494,16.745c0,-1.41 -0.857,-2.224 -2.95,-2.441c-0.305,-0.03 -0.814,-0.059 -1.046,-0.059l-0,0.117c0.203,0.029 0.378,0.072 0.523,0.13c0.945,0.349 1.322,1.047 1.322,2.282c0,1.352 -0.305,1.991 -1.191,2.383c-0.204,0.088 -0.422,0.16 -0.654,0.204l-0,0.131c2.659,-0.102 3.996,-1.424 3.996,-2.747Zm-4.737,-2.5l-3.314,0l0,0.117c0.901,0.13 1.221,0.479 1.221,1.685l-0,5.654c-0,1.206 -0.32,1.555 -1.221,1.686l0,0.116l4.781,-0l0,-0.116c-0.959,-0.131 -1.467,-0.436 -1.467,-1.686l-0,-7.456Z",
    style: {
      fill: "#fff3cb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.156,16.745c-0,-1.41 -0.857,-2.224 -2.95,-2.441c-0.305,-0.03 -0.814,-0.059 -1.047,-0.059l0,0.117c0.204,0.029 0.378,0.072 0.524,0.13c0.944,0.349 1.322,1.047 1.322,2.282c0,1.352 -0.305,1.991 -1.192,2.383c-0.203,0.088 -0.421,0.16 -0.654,0.204l0,0.131c2.66,-0.102 3.997,-1.424 3.997,-2.747Zm-4.738,-2.5l-3.313,0l-0,0.117c0.901,0.13 1.221,0.479 1.221,1.685l-0,5.654c-0,1.206 -0.32,1.555 -1.221,1.686l-0,0.116l4.781,-0l0,-0.116c-0.959,-0.131 -1.468,-0.436 -1.468,-1.686l0,-7.456Z",
    style: {
      fill: "#fff3cb",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.8a965dac052ad51bfb3f11b3331f793d.svg";
export { ForwardRef as ReactComponent };